module.exports = __webpack_public_path__ + "img/mtt_4.1.10ad7c2e.png";